// extracted by mini-css-extract-plugin
export default {"catalogContainer":"MyDigitalCatalog_catalogContainer__TaxoQ"};